import { Component, inject, signal } from '@angular/core';
import { NZ_MODAL_DATA, NzModalFooterDirective, NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { EhrService } from '@beautyapp/core';
import { TranslatePipe } from '@ngx-translate/core';
import { InputModule } from '@beautyapp/form';
import { FormsModule } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzFormItemComponent, NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';

@Component({
  selector: 'beautyapp-form100-download',
  imports: [
    NzModalFooterDirective,
    TranslatePipe,
    InputModule,
    FormsModule,
    NzButtonModule,
    NzFormModule,
    NzInputModule,
  ],
  templateUrl: './form100-download.component.html',
  styleUrl: './form100-download.component.css'
})
export class Form100DownloadComponent {
  data = inject(NZ_MODAL_DATA);
  modalService = inject(NzModalService);
  modalRef = inject(NzModalRef);
  ehrService = inject(EhrService);


  sendToCompany = signal<string>('');

  downloadForm100() {
    this.ehrService.generateAndSaveForm100(this.data.ehrIds, this.data.userId, this.data.employeeId, this.sendToCompany()).subscribe(
      (res) => {
        console.log(res);
        if (res && res.url) {
          // Option 1: Open in new tab
          window.open(res.url, '_blank');
          this.modalRef.close(true);
        }
      }
    );
  }
}
